var map = {
	"./004-solar-panel.svg": "./src/assets/benefits/004-solar-panel.svg",
	"./012-energy.svg": "./src/assets/benefits/012-energy.svg",
	"./034-hydro-power.svg": "./src/assets/benefits/034-hydro-power.svg",
	"./039-charging.svg": "./src/assets/benefits/039-charging.svg",
	"./041-sprout.svg": "./src/assets/benefits/041-sprout.svg",
	"./043-energy-saving-light.svg": "./src/assets/benefits/043-energy-saving-light.svg",
	"./045-renewable-energy.svg": "./src/assets/benefits/045-renewable-energy.svg",
	"./arvores.jpg": "./src/assets/benefits/arvores.jpg",
	"./barris.jpg": "./src/assets/benefits/barris.jpg",
	"./carbon-dioxide.svg": "./src/assets/benefits/carbon-dioxide.svg",
	"./co2.jpg": "./src/assets/benefits/co2.jpg",
	"./co2_outline_black.svg": "./src/assets/benefits/co2_outline_black.svg",
	"./co2_outline_by.svg": "./src/assets/benefits/co2_outline_by.svg",
	"./economia.jpg": "./src/assets/benefits/economia.jpg",
	"./linhas-tracejadas.png": "./src/assets/benefits/linhas-tracejadas.png",
	"./oil-barrel.svg": "./src/assets/benefits/oil-barrel.svg",
	"./percentage.png": "./src/assets/benefits/percentage.png",
	"./percentage_blue.png": "./src/assets/benefits/percentage_blue.png",
	"./trees.svg": "./src/assets/benefits/trees.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/benefits sync recursive ^\\.\\/.*$";